import React from 'react';
import useDocumentPopup from '@/hooks/useDocumentPopup';
import { offlineDocumentRequest } from '@/utils/offlineDocument';


const AuthenticatedDocumentLink = ({ url, documentKey, orderNumber, onClick, children, ...props }) => {
  const request = offlineDocumentRequest(url);
  const key = documentKey || url;
  const openDocument = useDocumentPopup({ requests: [{ key, requestedUrl: url, url: request.url,
    offlineCopy: request.offline, orderNumber }] });
  const handleClick = (event) => {
    onClick?.(event);
    if (event.defaultPrevented) return;
    openDocument(key);
  };

  return (
    <button type="button" onClick={handleClick} {...props}>
      {children}
    </button>
  );
};


export default AuthenticatedDocumentLink;
